import type { Tese, TeseCreatePayload, TeseUpdatePayload } from "@/types/tese";

import { api, unwrap } from "./axiosConfig";

const base = "/api/v1/teses";

export const teseService = {
  async list(params?: {
    only_active?: boolean;
    limit?: number;
    offset?: number;
  }): Promise<Tese[]> {
    return unwrap(api.get(base, { params }));
  },

  async get(id: number): Promise<Tese> {
    return unwrap(api.get(`${base}/${id}`));
  },

  async create(payload: TeseCreatePayload): Promise<Tese> {
    return unwrap(api.post(base, payload));
  },

  async update(id: number, payload: TeseUpdatePayload): Promise<Tese> {
    return unwrap(api.patch(`${base}/${id}`, payload));
  },

  async remove(id: number): Promise<void> {
    await api.delete(`${base}/${id}`);
  },
};
